<template lang="pug">
  #app
    div#the-container(is-fullhd)
      ecoinvent-header#the-header
      div#the-content
        transition(name="fade" mode="out-in" :duration="50")
          .container
            router-view
      ecoinvent-footer#the-footer
    vue-progress-bar
</template>

<script>
import EcoinventFooter from './components/EcoinventFooter'
import EcoinventHeader from './components/EcoinventHeader'

export default {
  name: 'App',
  components: { EcoinventFooter, EcoinventHeader }
}
</script>

<style lang="scss">

html, body, #app {
    height: 100%;
}

div#the-container {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

div#the-content {
    flex-grow: 1;
}

#the-header, #the-content, #the-footer {
    flex-shrink: 0;
}

// Import bulma utilities first
@import "~bulma/sass/utilities/_all";

// Define colors
$ecoinvent-red: #e01a1a;
$ecoinvent-red-invert: findColorInvert($ecoinvent-red);
$red: #eb6666;
$red-invert: findColorInvert($primary);
$green: #83b692;
$green-invert: findColorInvert($primary);
$blue: #d0cfec;
$blue-invert: findColorInvert($primary);
$yellow: #e6c79c;
$yellow-invert: findColorInvert($primary);

$navbar-dropdown-arrow: black;
$navbar-dropdown-radius: 0;
$navbar-dropdown-boxed-radius: 0;
$navbar-tab-hover-background-color: white;

$tabs-link-active-border-bottom-color: $text-strong;
$tabs-link-active-color: $text-strong;

$colors: (
  "green": ($green, $green-invert),
  "primary": ($green, $green-invert),
  "info": ($ecoinvent-red, $ecoinvent-red-invert),
  "success": ($blue, $blue-invert),
  "warning": ($yellow, $yellow-invert),
  "danger": ($red, $red-invert),
);

// Import bulma and buefy styles
@import '~bulma';
@import '~buefy/src/scss/buefy';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue